import script from "./mrInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./mrInput.vue?vue&type=script&setup=true&lang=ts"

import "./mrInput.vue?vue&type=style&index=0&id=74e3dd8c&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74e3dd8c"]])

export default __exports__